<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        Request.do(payload, 'GET', Request.getDefaultHeader(payload), null, `${Endpoints.parts.parts.part}`,
        (response)=>{//SUCCESS CALLBACK
            payload.items = response.results;
        },
        (error)=>{//ERROR CALLBACK
            console.log(error);
        });
    },
    methods:{
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        camelize: Common.camelize
    }
}
</script>
